// API and WebSocket created_at already contain the verified source time.
// Scope presentation changes to the server-enabled WhatsApp activity adapter.
export function orderedMessages(chat, messages = chat.messages || []) {
  if (!chat.message_activity_enabled) return messages;
  const seen = new Set();
  return messages.filter(message => {
    if (message.id == null) return true;
    if (seen.has(message.id)) return false;
    seen.add(message.id);
    return true;
  }).slice().sort((a, b) => {
    const time = Number(a.created_at) - Number(b.created_at);
    if (Number.isFinite(time) && time !== 0) return time;
    // Optimistic UUID messages retain their stable input position until confirmed.
    if (Number.isSafeInteger(a.id) && Number.isSafeInteger(b.id)) return a.id - b.id;
    return 0;
  });
}
export function normalizeMessageOrder(chat) {
  if (chat?.message_activity_enabled && chat.messages) chat.messages = orderedMessages(chat);
}
